import { Box, TableCell, TableEditableCell, Text } from '@razorpay/blade/components';
import React from 'react';
import { DECIMAL_ONLY_REGEX_WITH_2_DECIMALS } from 'utils/regexes';
import { useSalaryStructure } from '../context/SalaryStructureProvider';
import { SalaryStructureComponentProps } from '../types';

const areEqual = (
  prevProps: SalaryStructureComponentProps,
  nextProps: SalaryStructureComponentProps,
) => {
  return (
    prevProps.item.formula === nextProps.item.formula &&
    prevProps.item.salaryComponent.id === nextProps.item.salaryComponent.id
  );
};

const AmountCell = ({ item }: SalaryStructureComponentProps) => {
  const amount = item.formula ?? '';
  const isSpecialAllowance = item.salaryComponent.name === 'Special Allowance';

  const { updateAmount } = useSalaryStructure();

  if (isSpecialAllowance) {
    return (
      <TableCell>
        <Box paddingX="spacing.2">
          <Text size="large" color="surface.text.gray.subtle">
            Residual component
          </Text>
        </Box>
      </TableCell>
    );
  }

  const handleAmountChange = (value?: string) => {
    if (value && value.match(DECIMAL_ONLY_REGEX_WITH_2_DECIMALS)) {
      updateAmount(item.id.toString(), value);
    } else {
      updateAmount(item.id.toString(), '');
    }
  };

  return (
    <TableEditableCell
      placeholder="Amount"
      accessibilityLabel="Amount"
      value={amount}
      onChange={(e) => handleAmountChange(e.value)}
    />
  );
};

AmountCell.displayName = 'AmountCell';

export default React.memo(AmountCell, areEqual);
